import { render, staticRenderFns } from "./AppRefresh.vue?vue&type=template&id=ddaa579c&scoped=true"
import script from "./AppRefresh.vue?vue&type=script&lang=js"
export * from "./AppRefresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaa579c",
  null
  
)

export default component.exports